import { useIntl } from 'react-intl'
import HeadData from 'components/Common/HeadData'

function CruiseShipsHeadData(props: { shipName: string }) {
  const intl = useIntl()
  const { shipName } = props
  const currentYear = new Date().getFullYear()
  const title = intl.formatMessage(
    {
      id: 'TKR3SaCuuNbvwKXuBt5u',
      defaultMessage: '{shipName} | Best Deals {currentYear}/{nextYear}/{followingYear}',
      description: 'SEO page title for cruise ship deals page shown in browser tab and search results',
    },
    { shipName, currentYear, nextYear: currentYear + 1, followingYear: currentYear + 2 },
  )
  const description = intl.formatMessage(
    {
      id: 'PnXBFdREqreFOPn6Q7qU',
      defaultMessage: 'Set sail on {shipName} with exclusive deals from Luxury Escapes. Reserve your stateroom before it sells out.',
      description: 'SEO meta description for cruise ship deals page shown in search engine results',
    },
    { shipName },
  )

  return <HeadData title={title} description={description} />
}

export default CruiseShipsHeadData
